type TPosition = 'left' | 'right'

export function formatMoney(value?: number, unit?: string, position?: TPosition, stockType?: string): string {
  if (stockType === 'YbCar') return '-' 
  if (!value && value !== 0) return ''
  const values = value.toString().split('.')
  let newValue = values[0]
    .split('')
    .reverse()
    .reduce(function (acc, num, i) {
      return num + (num != '-' && i && !(i % 3) ? ',' : '') + acc
    }, '')

  if (values[1]) {
    newValue += '.'
    newValue += values[1]
  }

  if (unit) {
    if (position === 'left') {
      newValue = ' ' + newValue
      newValue = unit + newValue
    } else {
      newValue += ' '
      newValue += unit
    }
  }

  return newValue
}
